import React, { useState } from "react";
import { Input, Typography, Button, Form, Col, Row, Upload, Spin } from "antd";
import {
  DeleteOutlined,
  SendOutlined,
  SettingOutlined,
  PaperClipOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { ConnectedProps } from "react-redux";

import {
  NavigationPath,
  getFileUrl,
  history,
  responseFormLayout as layout,
} from "../../../../utils";
import { ResponseFormType } from "../../../../models";
import connector from "./Container";

const { TextArea } = Input;

const ResponseForm = ({ actions, state }: ConnectedProps<typeof connector>) => {
  const { loading, requestDetails } = state;
  const { id } = useParams();
  const [form] = Form.useForm<ResponseFormType>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const onFinish = (values: ResponseFormType) => {
    if (!selectedFile) {
      return;
    }
    id && actions.addInsuranceOfferResponse(id, values);
  };

  const onReset = () => {
    form.resetFields();
    setSelectedFile(null);
    history.navigate(NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE);
  };

  const handleFileSelect = (info: any) => {
    if (info.file) {
      setSelectedFile(info.file);
      form.setFieldsValue({ file: info.file });
    }
  };

  const handleFileRemove = () => {
    setSelectedFile(null);
    form.setFieldsValue({ file: null });
  };

  return (
    <div className="flex justify-center items-center">
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-center mb-6 text-secondary">
          POŠALJI PONUDU NA ODABRANI ZAHTJEV:
          <span className="text-offer-blue ml-2">{requestDetails?.name}</span>
        </Typography>
        <Form {...layout} form={form} name="basic" onFinish={onFinish}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Premija AK"
                name="premiumAK"
                rules={[
                  {
                    required: true,
                    message: "Unesite premiju AK!",
                  },
                ]}
              >
                <Input placeholder="Unesite premiju AK" />
              </Form.Item>

              <Form.Item
                label="Premija AO"
                name="premiumAO"
                rules={[
                  {
                    required: true,
                    message: "Unesite premiju AO!",
                  },
                ]}
              >
                <Input placeholder="Unesite premiju AO" />
              </Form.Item>

              <Form.Item
                label="Full troškovi registracije"
                name="fullRegistrationCost"
                rules={[
                  {
                    required: true,
                    message: "Unesite troškove registracije!",
                  },
                ]}
              >
                <Input placeholder="Unesite troškove registracije" />
              </Form.Item>

              <Form.Item
                label="Osigurana suma"
                name="insuredSum"
                rules={[
                  {
                    required: true,
                    message: "Unesite osiguranu sumu!",
                  },
                ]}
              >
                <Input placeholder="Unesite osiguranu sumu" />
              </Form.Item>

              <Form.Item label="Napomena" name="note">
                <TextArea
                  className="h-24"
                  placeholder="Upiši prijedlog / primjedbu"
                />
              </Form.Item>

              <Form.Item
                label="Prilog"
                name="file"
                rules={[
                  {
                    required: true,
                    message: "Odaberite prilog!",
                  },
                ]}
              >
                <div>
                  <Upload
                    showUploadList={false}
                    customRequest={handleFileSelect}
                  >
                    <Button
                      className="rounded-sm text-black"
                      icon={<SettingOutlined />}
                    >
                      Klikni da dodaš
                    </Button>
                  </Upload>
                  {selectedFile && (
                    <div className="flex w-full mt-6 bg-light-gray">
                      <PaperClipOutlined className="ml-2 text-black opacity-45" />
                      <div className="flex justify-between items-center w-full">
                        <a
                          className="ml-2 text-primary"
                          href={getFileUrl(selectedFile)}
                          download={selectedFile.name}
                        >
                          {selectedFile.name}
                        </a>
                        <Button
                          type="text"
                          onClick={handleFileRemove}
                          className="border-none bg-light-gray"
                        >
                          <DeleteOutlined className="mb-2 text-black opacity-45" />
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </Form.Item>

              <div className="flex justify-center space-x-4 mt-4">
                <Button
                  className="text-sm text-white bg-primary font-medium md:w-[132px] rounded-sm border-primary shadow-sm"
                  icon={<SendOutlined />}
                  htmlType="submit"
                  disabled={loading}
                >
                  Pošalji
                </Button>
                <Button
                  className="text-sm text-white bg-ternary font-medium md:w-[132px] rounded-sm border-primary shadow-sm"
                  icon={<DeleteOutlined />}
                  onClick={onReset}
                  disabled={loading}
                >
                  Otkaži
                </Button>
                {loading && (
                  <Spin
                    className="w-full sm:w-fit"
                    indicator={
                      <LoadingOutlined style={{ fontSize: 32 }} spin />
                    }
                  />
                )}
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ResponseForm;
